import { message } from "antd";

export const Error = (msg: string) => message.error(msg, 3);
export const Success = (msg: string) => message.success(msg, 3);